import React, { useEffect, useState, useRef, useMemo } from "react";
import { AppBar } from "@material-ui/core";
import { combineProps } from "../../../../helpers/objectHelper";
import { ChatFooter } from "../../../../digitalArena/modules/ChatModule/components/ChatFooter";
import { PersonDetails } from "../../../../digitalArena/modules/ChatModule/components/PersonDetails";
import { chatStyle } from "../../../../digitalArena/modules/ChatModule/helpers/chat.helper";
import { MessageList } from "../../../../digitalArena/modules/ChatModule/components/MessageList";
import { init } from "../../../../components/EventLabel2/EventLabel2";

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const ChatFrame = (props) => {
  const [text, setText] = useState("");
  const { selectChat, selectedChat, chat, eventId, lang } = props;
  const lastMessageRef = useRef();
  const scrollRef = useRef();
  const textRef = useRef("");
  const prevLastMessage = usePrevious(lastMessageRef.current);
  textRef.current = text;

  useEffect(() => {
    init(eventId, "DIGITALMEETING.CHAT", lang);
    return () => {
    };
  }, []);

  useEffect(() => {
    if (lastMessageRef.current && !prevLastMessage && chat.length != 0 && scrollRef.current) {
      setTimeout(() => handleScroll(), 1500);
    } else if (lastMessageRef.current != prevLastMessage && chat.length != 0 && scrollRef.current) {
      handleScroll();
    }
  }, [lastMessageRef.current]);

  const handleScroll = () => {
    try {
      lastMessageRef.current.scrollIntoView({
        block: "end",
        behavior: "smooth",
      });
    } catch (error) {
      console.error(error);
    }
  };

  const typing = (text) => {
    setText(text);
  };

  const combinedProps = useMemo(() => {
    return {
      ...combineProps([
        props,
        {
          text,
          exhibitor: true,
          chats: chat,
          onTyping: typing,
          lastMessageRef,
          settings: {
            showUserProfileImage: true,
          },
          messagesToShow: 30,
          onScroll: () => null,
          scrollRef,
          deselectChat: () => selectChat(null),
          chatTemplate: chatStyle(),
          currentChat: selectedChat,
        },
      ]),
    };
  }, [props, text, selectedChat, chat]);

  return (
    <div
      className="chat-container exhibitor-chat-frame"
      style={{
        position: "relative",
        overflow: "hidden",
        width: props.videoCallTarget ? "calc((100vw - 240px - 500px) / 2)" : "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <AppBar position="static" className="chat-frame-header">
        <PersonDetails {...combinedProps} />
      </AppBar>
      <MessageList {...combinedProps} />
      <ChatFooter
        {...combineProps([
          props,
          {
            text,
            exhibitor: true,
            chats: chat,
            onTyping: typing,
            lastMessageRef,
            settings: {
              showUserProfileImage: true,
            },
            channel: `Expo:${props.exhibitorId}`,
            scrollRef,
            deselectChat: () => selectChat(null),
            chatTemplate: chatStyle(),
            currentChat: selectedChat,
          },
        ])}
      />
    </div>
  );
};
